import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Coffee, ArrowRight } from 'lucide-react';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-500 ${
      isScrolled 
        ? 'bg-white shadow-2xl border-b-4 border-orange-500' 
        : 'bg-transparent'
    }`}>
      <nav className="px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-center h-24">
            {/* Logo */}
            <Link to="/cinnamon-design-5" className="flex items-center space-x-4 group">
              <div className="relative">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 transform rotate-45 flex items-center justify-center shadow-xl group-hover:rotate-90 transition-transform duration-500">
                  <Coffee className="h-8 w-8 text-white transform -rotate-45 group-hover:rotate-0 transition-transform duration-500" />
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-yellow-400 rounded-full"></div>
              </div>
              <div>
                <div className={`text-3xl font-black tracking-tight transition-colors duration-300 ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`}>
                  CLAUDE'S
                </div>
                <div className={`text-sm font-bold tracking-widest transition-colors duration-300 ${
                  isScrolled ? 'text-orange-600' : 'text-orange-300'
                }`}>
                  SPECIAL
                </div>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-2">
              <Link
                to="/cinnamon-design-5"
                className={`relative px-8 py-4 text-lg font-bold transition-all duration-300 ${
                  isActive('/cinnamon-design-5') 
                    ? 'text-white bg-gradient-to-r from-orange-500 to-red-600 shadow-xl transform scale-105' 
                    : isScrolled
                      ? 'text-gray-800 hover:text-orange-600 hover:bg-orange-50'
                      : 'text-white hover:text-orange-300 hover:bg-white/10'
                } ${isActive('/cinnamon-design-5') ? '' : 'hover:transform hover:scale-105'}`}
              >
                HOME
                {isActive('/cinnamon-design-5') && <div className="absolute bottom-0 left-0 w-full h-1 bg-yellow-400"></div>}
              </Link>
              <Link
                to="/ceylon-cinnamon-design-5"
                className={`relative px-8 py-4 text-lg font-bold transition-all duration-300 ${
                  isActive('/ceylon-cinnamon-design-5') 
                    ? 'text-white bg-gradient-to-r from-orange-500 to-red-600 shadow-xl transform scale-105' 
                    : isScrolled
                      ? 'text-gray-800 hover:text-orange-600 hover:bg-orange-50'
                      : 'text-white hover:text-orange-300 hover:bg-white/10'
                } ${isActive('/ceylon-cinnamon-design-5') ? '' : 'hover:transform hover:scale-105'}`}
              >
                CINNAMON
                {isActive('/ceylon-cinnamon-design-5') && <div className="absolute bottom-0 left-0 w-full h-1 bg-yellow-400"></div>}
              </Link>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className={`p-3 transition-colors duration-200 ${
                  isScrolled 
                    ? 'text-gray-800 hover:bg-orange-100' 
                    : 'text-white hover:bg-white/20'
                }`}
              >
                {isOpen ? <X className="h-8 w-8" /> : <Menu className="h-8 w-8" />}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isOpen && (
            <div className="md:hidden pb-6">
              <div className="bg-white shadow-2xl border-4 border-orange-500 p-6 space-y-4">
                <Link
                  to="/cinnamon-design-5"
                  onClick={() => setIsOpen(false)}
                  className={`block px-6 py-4 text-xl font-bold transition-all duration-200 ${
                    isActive('/cinnamon-design-5') 
                      ? 'text-white bg-gradient-to-r from-orange-500 to-red-600' 
                      : 'text-gray-800 hover:text-orange-600 hover:bg-orange-50'
                  }`}
                >
                  HOME
                </Link>
                <Link
                  to="/ceylon-cinnamon-design-5"
                  onClick={() => setIsOpen(false)}
                  className={`block px-6 py-4 text-xl font-bold transition-all duration-200 ${
                    isActive('/ceylon-cinnamon-design-5') 
                      ? 'text-white bg-gradient-to-r from-orange-500 to-red-600' 
                      : 'text-gray-800 hover:text-orange-600 hover:bg-orange-50'
                  }`}
                >
                  CINNAMON
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;